import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import {
  getSipPlansRequest,
  getSipPlansSuccess,
  getSipPlansFailure,
  getSipTemplateRequest,
  getSipTemplateSuccess,
  getSipTemplateFailure,
  createOfflineSipPaymentRequest,
  createOfflineSipPaymentSuccess,
  createOfflineSipPaymentFailure,
  createOfflineSipInstallmentRequest,
  createOfflineSipInstallmentSuccess,
  createOfflineSipInstallmentFailure,
  createSipOfflineOrderRequest,
  createSipOfflineOrderSuccess,
  createSipOfflineOrderFailure,
} from "./sipSlice";

function* fetchSipPlans() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/get-sip-plans`
      )
    );

    if (response.data.success) {
      yield put(getSipPlansSuccess(response.data));
      // toast.success("SIP plans fetched successfully");
    } else {
      yield put(getSipPlansFailure(response.data.message));
      toast.error(response.data.message || "Failed to fetch SIP plans");
    }
  } catch (error) {
    yield put(getSipPlansFailure(error.message));
    toast.error(error.message || "Error fetching SIP plans");
  }
}

function* fetchSipTemplate(action) {
  try {
    const { page = 1, limit = 10, search = "" } = action.payload || {};

    const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/getsiptemplate?page=${page}&limit=${limit}&search=${search}`;

    const response = yield call(() =>
      axios.get(url));

    if (response.data.success) {
      yield put(getSipTemplateSuccess(response.data));
      // toast.success("SIP templates fetched successfully");
    } else {
      yield put(getSipTemplateFailure(response.data.message));
      toast.error(response.data.message || "Failed to fetch SIP templates");
    }
  } catch (error) {
    yield put(getSipTemplateFailure(error.message));
    toast.error(error.message || "Error fetching SIP templates");
  }
}

function* createOfflineSipPayment(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/createSipOffline`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data.success) {
     yield put(createOfflineSipPaymentSuccess(response.data));
     //toast.success("Offline SIP order created successfully");
    } else {
    yield put(createOfflineSipPaymentFailure(response.data.message));
      toast.error(response.data.message || "Failed to create offline SIP order");
    }
  } catch (error) {
    yield put(
      createOfflineSipPaymentFailure(error.response?.data?.message || error.message),
    );
  }
}

function* createOfflineSipInstallment(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/paySipInstallment`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data.success) {
     yield put(createOfflineSipInstallmentSuccess(response.data));
     toast.success("Offline SIP order created successfully");
    } else {
    yield put(createOfflineSipInstallmentFailure(response.data.message));
      toast.error(response.data.message || "Failed to create offline SIP order");
    }
  } catch (error) {
    yield put(
      createOfflineSipInstallmentFailure(error.response?.data?.message || error.message),
    );
  }
}

function extractOrderId(body) {
  const data = body?.data;
  if (typeof data === "string" && data.trim()) return data.trim();
  return (
    data?.orderId ||
    data?.orderID ||
    data?.order_id ||
    body?.orderId ||
    body?.orderID ||
    ""
  );
}

function* createSipOfflineOrder(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/sipOffline`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const body = response.data || {};
    const orderId = extractOrderId(body);

    if (body.success === false || !orderId) {
      const message = body.message || body.errormsg || "Failed to create offline SIP order";
      yield put(createSipOfflineOrderFailure(message));
      toast.error(message);
      return;
    }

    yield put(createSipOfflineOrderSuccess({ orderId }));
    toast.success(body.message || "Offline SIP order created successfully");
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.errormsg ||
      error.message ||
      "Failed to create offline SIP order";
    yield put(createSipOfflineOrderFailure(message));
    toast.error(message);
  }
}

export function* sipSaga() {
  yield takeLatest(getSipPlansRequest.type, fetchSipPlans);
  yield takeLatest(getSipTemplateRequest.type, fetchSipTemplate);
  yield takeLatest(createOfflineSipPaymentRequest.type, createOfflineSipPayment);
  yield takeLatest(createOfflineSipInstallmentRequest.type, createOfflineSipInstallment);
  yield takeLatest(createSipOfflineOrderRequest.type, createSipOfflineOrder);
}
